import { clsx } from 'clsx';
import Avatar from "../Avatar";
import { Clamp } from "../Clamp";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export var AvatarUser = function AvatarUser(_ref) {
  var avatar = _ref.avatar,
    fullName = _ref.fullName,
    email = _ref.email,
    onClick = _ref.onClick,
    hideAvatar = _ref.hideAvatar,
    className = _ref.className,
    subtitle = _ref.subtitle;
  var handleOnClick = function handleOnClick(event) {
    event.stopPropagation();
    onClick === null || onClick === void 0 ? void 0 : onClick();
  };
  return /*#__PURE__*/_jsxs("div", {
    className: clsx('tw-flex tw-gap-1 tw-justify-center tw-min-w-0', className),
    children: [!hideAvatar && /*#__PURE__*/_jsx("button", {
      onClick: handleOnClick,
      type: "button",
      children: /*#__PURE__*/_jsx(Avatar, {
        src: avatar
      })
    }), /*#__PURE__*/_jsxs("div", {
      className: "tw-flex tw-flex-col tw-items-start tw-justify-start tw-gap-0.4 tw-min-w-0",
      children: [/*#__PURE__*/_jsx("button", {
        onClick: handleOnClick,
        type: "button",
        className: "tw-truncate tw-w-full",
        children: /*#__PURE__*/_jsx(Clamp, {
          lines: 1,
          className: clsx('tw-text-left tw-font-link1 dark:tw-text-neutral-light-100 tw-w-full', onClick && 'tw-cursor-pointer'),
          children: fullName || email
        })
      }), fullName && (email || subtitle) && /*#__PURE__*/_jsx(Clamp, {
        lines: 1,
        className: "tw-text-left tw-font-body5 tw-text-neutral-light-700 dark:tw-text-neutral-dark-400 tw-w-full",
        children: subtitle || email
      })]
    })]
  });
};